export enum ThunkStatus {
  Pending = "pending",
  Idle = "idle",
  Failed = "failed",
}
